import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  TabPane,
  NavLink,
  NavItem,
  TabContent,
  Nav,
} from 'reactstrap';
import {withTranslation} from "react-i18next";
import {Colxx} from '../../components/common/CustomBootstrap';
import Api from "../../services/Api";
import classnames from "classnames";
import Balances from "./Balances";
import JobRequests from "./JobRequests";
import JobRuns from "./JobRuns";
import {getStatusColor, mapStatus} from "../../helpers/Utils";

class ZarinpalTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      balances: [],
      status: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      await Promise.all([
        this.fetchBalances(),
        this.fetchStatus(),
      ]);
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  fetchStatus = async () => {
    const {userId} = this.props;
    try {
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/transfers/services/status',
        null,
        {
          params: {
            userId,
            transferServiceName: 'ZARINPAL',
          }
        },
      );
      this.setState({
        status: data[0],
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchBalances = async () => {
    const {userId} = this.props;
    try {
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/transfers/services/balances',
        null,
        {
          params: {
            userId,
            transferServiceName: 'ZARINPAL',
          }
        },
      );
      this.setState({
        balances: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {t, userId} = this.props;
    const {activeTab, balances, status, loading} = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="d-flex flex-row justify-content-between align-items-center text-large text-primary mb-5">
                {t('Zarinpal Transfers')}
                {!!status &&
                  <div className="d-flex flex-row align-items-center text-medium">
                    {typeof status.userAuth !== "undefined" &&
                      <span className="mr-4">
                        {`${t('Auth status')}: `}
                        <span className={getStatusColor(status.userAuth)}>
                          {mapStatus(status.userAuth)}
                        </span>
                      </span>
                    }
                    {typeof status.enabled !== "undefined" &&
                      <span>
                        {`${t('Service status')}: `}
                        <span className={`font-weight-semibold ${status.enabled ? 'text-success' : 'text-danger'}`}>
                          {status.enabled ? t('Enabled') : t('Disabled')}
                        </span>
                      </span>
                    }
                  </div>
                }
              </CardTitle>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 0 })}
                    onClick={() => {this.toggle(0);}}>
                    <span className="text-one cursor-pointer">{t('Balances')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {this.toggle(1);}}>
                    <span className="text-one cursor-pointer">{t('Requests')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {this.toggle(2);}}>
                    <span className="text-one cursor-pointer">{t('Operations')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={0}>
                  <Balances
                    data={balances}
                    loading={loading}
                  />
                </TabPane>
                <TabPane tabId={1}>
                  <JobRequests
                    userId={userId}
                    balances={balances}
                    fetchBalances={this.fetchBalances}
                  />
                </TabPane>
                <TabPane tabId={2}>
                  <JobRuns userId={userId}/>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(ZarinpalTransfer);
